import { useEffect } from 'react';
import { DEFAULT_FAVICON_HREF, DEFAULT_FAVICON_TYPE } from '@/constants/branding';
import { useBranding } from '@/hooks/useBranding';

function resolveFaviconLinkElement(): HTMLLinkElement | null {
  return document.querySelector('link[rel="icon"]');
}

export function useBrandFavicon(): void {
  const { logos } = useBranding();
  const iconLogoUrl = logos.icon;

  useEffect(
    function applyFavicon() {
      const faviconLinkElement = resolveFaviconLinkElement();
      if (faviconLinkElement === null) {
        return;
      }
      if (iconLogoUrl === null) {
        faviconLinkElement.href = DEFAULT_FAVICON_HREF;
        faviconLinkElement.type = DEFAULT_FAVICON_TYPE;
        return;
      }
      faviconLinkElement.href = iconLogoUrl;
      faviconLinkElement.removeAttribute('type');
    },
    [iconLogoUrl]
  );
}
